module.exports = __webpack_public_path__ + "assets/img/scoop.98faf217.png";